function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Dark Logo");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "logo---square",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M31,30 C24.9248678,30 20,25.0751322 20,19 C20,12.9248678 24.9248678,8 31,8 C37.0751322,8 42,12.9248678 42,19 C42,25.0751322 37.0751322,30 31,30 Z M31,56 C24.9248678,56 20,51.0751322 20,45 C20,38.9248678 24.9248678,34 31,34 C37.0751322,34 42,38.9248678 42,45 C42,51.0751322 37.0751322,56 31,56 Z M69,93 C62.9248678,93 58,88.0751322 58,82 C58,75.9248678 62.9248678,71 69,71 C75.0751322,71 80,75.9248678 80,82 C80,88.0751322 75.0751322,93 69,93 Z",
  id: "Combined-Shape"
}), React.createElement("path", {
  d: "M33.1517734,77.359375 L22.6315913,66.690287 C21.5725311,65.6162366 21.564254,63.893258 22.6129462,62.809082 C23.6288404,61.7588138 25.303796,61.7309481 26.3540642,62.7468423 C26.3698733,62.762134 26.3854912,62.7776223 26.4009141,62.7933035 L40.7270508,77.359375 L26.3928091,91.9336872 C25.3683251,92.9753293 23.693399,92.9892387 22.651757,91.9647547 C22.6386853,91.9518984 22.6257477,91.9389066 22.6129462,91.9257812 C21.5651121,90.8514452 21.5686992,89.1364431 22.6210183,88.0664997 L33.1517734,77.359375 Z M69,7 C75.0751322,7 80,11.9248678 80,18 L80,53 C80,59.0751322 75.0751322,64 69,64 C62.9248678,64 58,59.0751322 58,53 L58,18 C58,11.9248678 62.9248678,7 69,7 Z",
  id: "Combined-Shape"
}));

var SvgSmLogo = function SvgSmLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSmLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smLogo.3388011c.svg";
export { ForwardRef as ReactComponent };